import { styled } from '@linaria/react';
import { motion } from 'framer-motion';

function LayoutElement({ ref, children, ...delegated }) {
  return (
    <Wrapper ref={ref} layout {...delegated}>
      <InnerWrapper layout={true}>
        <motion.span layout>{children}</motion.span>
      </InnerWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  position: relative;
  background: hsl(220deg 20% 40%);
  border-radius: 2px;
  padding: 4px;
`;

const InnerWrapper = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: hsl(220deg 20% 40%);
  padding: 0 16px;
  font-family: var(--font-family-mono);
  background: white;
  overflow: hidden;
  overflow: clip;
  height: 100%;
`;

export default LayoutElement;
